import { computed, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppEntry } from '../models/app-entry.model';
import { AppRegistryService } from './app-registry.service';

@Injectable({ providedIn: 'root' })
export class ActiveAppService {
  private readonly router = inject(Router);
  private readonly registry = inject(AppRegistryService);

  readonly activeAppId = signal<string | null>(null);

  readonly activeApp = computed<AppEntry | null>(() => {
    const id = this.activeAppId();
    return id ? (this.registry.getById(id) ?? null) : null;
  });

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(e => {
        const segment = e.urlAfterRedirects.split('/').filter(Boolean)[0] ?? '';
        const found = this.registry.apps.find(a => a.route === `/${segment}`);
        this.activeAppId.set(found?.id ?? null);
      });
  }
}
